// This class keeps a cache of Promises that resolve to images for all images that it's been
// requested in the past to load.
export default class {
  #queue = [];
  #cache = {};
  #config;
  #imageSource;
  #imageSuffix;

  #loadNext = async () => {
    if (this.#queue.length > 0) {
      const scene = this.#queue.pop();
      await this.load(scene, 'd');
      this.#loadNext();
    }
  };

  #getUrl = (scene, i) => {
    const filename = `${typeof i === 'number' ? (this.#imageSuffix ? 'a' : 'c') : ''}${i}${this.#imageSuffix ? `_${this.#imageSuffix}` : ''}`;
    return `${this.#imageSource}${scene.code}/${filename}.jpg?v=${scene.version}`;
  }

  constructor(config, imageSource, imageSuffix) {
    this.#config = config;
    this.#imageSuffix = imageSuffix;
    this.#imageSource = imageSource;
  }

  load = (scene, i) => {
    const url = this.#getUrl(scene, i);
    this.#cache[url] ??= new Promise(resolve => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => resolve(img);
      img.src = url;
    });
    return this.#cache[url];
  }

  hasInCache = (scene, i) => {
    return !!this.#cache[this.#getUrl(scene, i)];
  }

  preload = (sceneCodes) => {
    this.#queue = sceneCodes.map(t => this.#config.scenesByCode[t]);
    this.#loadNext();
  };
}
